import { Directive, Input, ComponentFactoryResolver, ViewContainerRef, OnInit } from '@angular/core';
import { FormBaseConfig } from '../models/form-field.model';
import { FormAccordionComponent } from '../templates/form-accordion/form-accordion.component';
import { FormGridComponent } from '../templates/form-grid/form-grid.component';
import { FormInlineComponent } from '../templates/form-inline/form-inline.component';
import { FormGroup } from '@angular/forms';
import { FormConfigInstance } from '../services/form.service';

const componentMapper = {
  accordion: FormAccordionComponent,
  grid: FormGridComponent,
  inline: FormInlineComponent
};

@Directive({
  selector: '[gioFormTemplate]'
})
export class FormTemplateDirective implements OnInit {

  @Input() form: FormGroup;
  @Input() service: FormConfigInstance;

  componentRef: any;

  constructor(
    private resolver: ComponentFactoryResolver,
    private container: ViewContainerRef
  ) { }

  ngOnInit() {
    const factory = this.resolver.resolveComponentFactory(
      componentMapper[this.service.params.template] as any
    );
    this.componentRef = this.container.createComponent(factory);
    this.componentRef.instance.service = this.service;
    this.componentRef.instance.form = this.form;

  }

}
